import { z } from 'zod';

/**
 * Схемы инструментов автора (Веха 7, work/007 §M2).
 *
 * Источник правды:
 *   - CANON §2.B/B4 + SP4: блокировка отправителя оперирует `questionId`, НЕ
 *     fingerprint'ом — сервер резолвит fingerprint сам, клиент его НИКОГДА не
 *     видит. Скрытие/жалоба/тоггл бокса — операции над собственными ресурсами.
 *   - CANON §2.D (zod-strict): все .strict().
 *   - CANON D3: ownership проверяется на сервере; клиент шлёт только id.
 *
 * Единый opaque-ответ `{ ok: true }` — никаких подробностей наружу (B2/SP4).
 */

const ID = z.string().min(1).max(64);

/** Скрыть / показать вопрос в inbox'е (status='hidden' ↔ восстановление). */
export const HideQuestionBody = z
  .object({ questionId: ID, hidden: z.boolean() })
  .strict();
export type HideQuestionBody = z.infer<typeof HideQuestionBody>;

/** Пожаловаться на вопрос. reason — закрытый список (не свободный текст → privacy/storage). */
export const ReportReason = z.enum(['spam', 'harassment', 'sexual', 'other']);
export type ReportReason = z.infer<typeof ReportReason>;

export const ReportQuestionBody = z
  .object({ questionId: ID, reason: ReportReason })
  .strict();
export type ReportQuestionBody = z.infer<typeof ReportQuestionBody>;

/**
 * Заблокировать / разблокировать отправителя ПО вопросу (CANON B4).
 * Сервер резолвит `question.senderFingerprint` + `box.ownerId` — клиент
 * fingerprint НЕ передаёт и НЕ получает (SP4).
 */
export const BlockSenderBody = z
  .object({ questionId: ID, blocked: z.boolean() })
  .strict();
export type BlockSenderBody = z.infer<typeof BlockSenderBody>;

/** Включить / выключить ящик (приём вопросов). */
export const ToggleBoxBody = z
  .object({ boxId: ID, active: z.boolean() })
  .strict();
export type ToggleBoxBody = z.infer<typeof ToggleBoxBody>;

/** Общий opaque-ответ author-tool эндпоинтов. */
export const AuthorActionResponse = z.object({ ok: z.literal(true) }).strict();
export type AuthorActionResponse = z.infer<typeof AuthorActionResponse>;
